module.exports = __webpack_public_path__ + "img/icon_success.7c4c6763.png";